import firebase from "firebase/compat/app";
//auth
import { getAuth } from "firebase/auth";
import "firebase/compat/firestore";
import "firebase/compat/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAI1auMYqB0HyYYoUZoYLxLxUstyE_WwYE",
  authDomain: "clone-27f53.firebaseapp.com",
  projectId: "clone-27f53",
  storageBucket: "clone-27f53.firebasestorage.app",
  messagingSenderId: "242412316046",
  appId: "1:242412316046:web:b72239f5bb3fca04b7b0df",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = app.firestore();
